import { constants } from "../../../misc/helpers";
import MainTutorialScenario from "./MainTutorialScenario";

export default class MainTutorialScenarioSteps9And10And11 {
	constructor(private mainScenario: MainTutorialScenario, private onDone: () => void) {
	}

	public start() {
		this.mainScenario.doStuffIfStepsWereSkipped();
		this.step10BleedoutTimerStart();
	}

	step10BleedoutTimerStart() {
		var context = this;
		context.mainScenario.playSequence('ResetTourniquete', null, () => {
			context.mainScenario.playSequence('DisablePressureInVictim');
		context.mainScenario.playSequence("TransitionToUnsafe", null, () => {
		});
	});
		this.mainScenario.changeArea('Default', () => {
			context.mainScenario.playSound('5', '1', () => {
				context.mainScenario.playSound('5', '2', () => {
					var data = {
						disabled: true,
						title: 'Should the victim be moved?',
						correctButton: {
							title: 'Yes',
							onClick: () => {
								context.mainScenario.gameManager.UiManager.hideaAllUis();
								context.mainScenario.playSequence('Step1SetPatientLocation');
								context.step11PatientInteract();
							}
						},
						incorrectButton: {
							title: 'No',
							greyedOut: true,
							onClick: () => { }
						}
					};

					context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
						dispatch: this.mainScenario.gameManager.customData.dispatch,
						startTimeInSeconds: 240,
						setRedEffect: true,
						isActive: true,
						isTutorial: true
					});

					context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.PauseMenuTutorial);

					context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.PauseMenu, {
						timer: {
							dispatch: this.mainScenario.gameManager.customData.dispatch,
							penalized: false,
							startTimeInSeconds: 240,
							setRedEffect: true,
							isActive: true
						}
					});

					context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BinaryQuestion, data);
					context.mainScenario.playSound('5', '3', () => {
						context.mainScenario.playSound('5', '4', () => {
							data.disabled = false;
							context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BinaryQuestion, data);
						});
					});
				});
			});
		});
	}

	step11PatientInteract() {
		var context = this;

		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			penalized: true,
			timePenaltyInSeconds: 28,
			setRedEffect: true,
			isActive: true,
			isTutorial: true
		});

		context.mainScenario.playSound('5', '5', () => {
			var data = {
				disabled: true,
				title: 'Should the victim be moved again?',
				correctButton: {
					title: 'Yes',
					onClick: () => {
						context.mainScenario.gameManager.UiManager.hideaAllUis();
						context.mainScenario.playSequence('Step2SetPatientLocation');
						context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
							dispatch: this.mainScenario.gameManager.customData.dispatch,
							penalized: true,
							timePenaltyInSeconds: 28,
							setRedEffect: true,
							isActive: true,
							isTutorial: true
						});
						context.mainScenario.playSound('5', '7', () => {
							context.step2TryAgain()
						});
					}
				},
				incorrectButton: {
					title: 'No',
					greyedOut: true,
					onClick: () => { }
				}
			};
			context.mainScenario.playSound('5', '6', () => {
				data.disabled = false;
				context.mainScenario.gameManager.UiManager.hideaAllUis();
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BinaryQuestion, data);
			});

			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BinaryQuestion, {
				title: 'Should the victim be moved again?',
				correctButton: {
					title: 'Yes',
					greyedOut: true,
					onClick: () => { }
				},
				incorrectButton: {
					title: 'No',
					greyedOut: true,
					onClick: () => { }
				}
			});
		});
	}

	private step2TryAgain() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to try again?',
			correctButton: {
				title: 'Try Again',
				greyedOut: true,
				onClick: () => { }
			},
			incorrectButton: {
				title: 'Next',
				greyedOut: true,
				onClick: () => { }
			}
		});
		context.mainScenario.playSound('5', '8', () => {
		});
				context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
				context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
					title: 'Would you like to try again?',
					correctButton: {
						title: 'Try Again',
						onClick: () => context.step10BleedoutTimerStart()
					},
					incorrectButton: {
						title: 'Next',
						onClick: () => context.step2TryAgainAfter()
					}
				});

	}

	private step2TryAgainAfter() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
		context.onDone();
	}

}